// extracted by mini-css-extract-plugin
export default {"paymentSection":"c9-z"};